const en = {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    cancelDelete: 'Cancel deletion',
    edit: 'Edit',
    add: 'Add',
    create: 'Create',
    back: 'Back',
    search: 'Search',
    remove: 'Remove',
    close: 'Close',
    closeMenu: 'Close menu',
    loading: 'Loading...',
    somethingWentWrong: 'Something went wrong',
    yes: 'Yes',
    no: 'No',
    required: 'Required',
    noResults: 'No results',
    home: 'Home',
    link: 'Link',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
  },
  serviceUnavailable: {
    title: 'Service unavailable',
    message: 'We are unable to reach the service right now.<br/>Please try again in a few moments.',
    retry: 'Try again',
    retryCooldown: 'Try again ({{seconds}})',
  },
  header: {
    welcome: 'Welcome,',
    logout: 'Log out',
    language: 'Language',
    languageGreek: 'Ελληνικά',
    languageEnglish: 'English',
  },
  branchSelector: {
    selectBranchTitle: 'Select branch',
    selectBranchLabel: 'Select branch:',
    save: 'Save',
  },
  menu: {
    overview: 'Overview',
    contacts: 'Contacts',
    leads: 'Leads',
    companies: 'Companies',
    orders: 'Orders',
    employees: 'Employees',
    bookings: 'Calendar',
    services: 'Services',
    settings: 'Settings',
    statistics: 'Statistics',
    ergani: 'ERGANI',
  },
  breadcrumbs: {
    contacts: 'Contacts',
    services: 'Services',
    employees: 'Employees',
    orders: 'Orders',
    settings: 'Settings',
    employeePlan: 'Calendar',
  },
  enums: {
    companyType: {
      IKE: 'Private capital company',
      EPE: 'Limited liability company',
      AE: 'Public limited company',
      OE: 'General partnership',
      EE: 'Limited partnership',
      SOLE_PROPRIETORSHIP: 'Sole proprietorship',
    },
    companyRole: {
      OWNER: 'Owner',
    },
    bookingStatus: {
      ACTIVE: 'Active',
      COMPLETED: 'Completed',
      CANCELLED: 'Cancelled',
      NO_SHOW: 'No show',
      PENDING: 'Unconfirmed',
    },
    communicationStatus: {
      DRAFT: 'Draft',
      IN_PROGRESS: 'In progress',
      RECALL: 'Recall',
      REJECTED: 'Rejected',
      COMPLETED: 'Completed',
    },
    orderStatus: {
      DRAFT: 'Draft',
      SUBMITTED: 'Submitted',
      UNDER_NEGOTIATION: 'Under Negotiation',
      ACCEPTED: 'Accepted',
      REJECTED: 'Rejected',
      CANCELLED: 'Cancelled',
      EXPIRED: 'Expired',
      PENDING: 'Pending',
      PROCESSING: 'Processing',
      COMPLETED: 'Completed',
      ON_HOLD: 'On Hold',
      FAILED: 'Failed',
      SHIPPED: 'Shipped',
    },
    gender: {
      FEMALE: 'Female',
      MALE: 'Male',
      OTHER: 'Other',
      UNKNOWN: 'Unknown',
    },
    dayOfWeek: {
      MONDAY: 'Monday',
      TUESDAY: 'Tuesday',
      WEDNESDAY: 'Wednesday',
      THURSDAY: 'Thursday',
      FRIDAY: 'Friday',
      SATURDAY: 'Saturday',
      SUNDAY: 'Sunday',
    },
    paymentMethod: {
      DOMESTIC_BUSINESS_PAYMENT_ACCOUNT: 'Domestic business payment account',
      FOREIGN_BUSINESS_PAYMENT_ACCOUNT: 'Foreign business payment account',
      CASH: 'Cash',
      CHECK: 'Cheque',
      ON_CREDIT: 'On credit',
    },
    invoicePaymentMethod: {
      DEBIT_CARD: 'Debit card',
      CREDIT_CARD: 'Credit card',
      CASH: 'Cash',
    },
    country: {
      AT: 'Austria',
      BE: 'Belgium',
      BG: 'Bulgaria',
      HR: 'Croatia',
      CY: 'Cyprus',
      CZ: 'Czechia',
      DK: 'Denmark',
      EE: 'Estonia',
      FI: 'Finland',
      FR: 'France',
      DE: 'Germany',
      GR: 'Greece',
      HU: 'Hungary',
      IE: 'Ireland',
      IT: 'Italy',
      LV: 'Latvia',
      LT: 'Lithuania',
      LU: 'Luxembourg',
      MT: 'Malta',
      NL: 'Netherlands',
      PL: 'Poland',
      PT: 'Portugal',
      RO: 'Romania',
      SK: 'Slovakia',
      SI: 'Slovenia',
      ES: 'Spain',
      SE: 'Sweden',
      GB: 'United Kingdom',
    },
  },
  searchDialogs: {
    company: {
      titleNew: 'Link company',
      titleEdit: 'Update contact-company link',
      companyLabel: 'Company',
      roleLabel: 'Role',
      saveButton: 'Save',
      linkButton: 'Link',
    },
    contact: {
      titleNew: 'Link contact',
      titleEdit: 'Update contact-company link',
      contactLabel: 'Contact',
      roleLabel: 'Role',
      saveButton: 'Save',
      linkButton: 'Link',
    },
  },
  contacts: {
    listTitle: 'Contacts',
    addContact: 'Create contact',
    backToList: 'Contacts list',
    createTitle: 'Create contact',
    select: 'Select',
    columns: {
      lastName: 'Last name',
      firstName: 'First name',
      mobilePhone: 'Mobile phone',
      additionalPhone: 'Landline phone',
      email: 'Email',
      source: 'Source',
      branch: 'Branch',
    },
    tooltips: {
      lead: 'Lead (has an offer/order)',
      customer: 'Customer (has a completed order)',
      mobileCheck: 'Check phone number usage in existing contacts',
    },
    search: {
      mobilePlaceholder: 'First name, Last name, Mobile, Email',
    },
    sections: {
      basicInfo: 'Basic information',
      contactInfo: 'Contact details',
      additionalInfo: 'Additional information',
      linkedCompanies: 'Linked companies',
      bookingReminders: 'Upcoming booking reminders',
    },
    reminders: {
      lede: 'What this client has agreed to receive before their upcoming bookings. This record applies to all of their bookings, not to any single one.',
      confirmationsNotice:
        'Booking confirmations and cancellations are always sent, whatever this record says. This governs the reminders before an upcoming booking — nothing else.',
      permanence:
        'Every change to this record is written permanently, against your name and the time you made it, and cannot be corrected or removed afterwards — including anything you gave as a reason.',
      // Shown only when the record itself is ready and something the section cannot display
      // is what blocks the save. A missing reason is never this: it says so in its own box.
      blockedElsewhere: 'This cannot be saved yet: another field on this contact needs fixing. Check the fields marked above.',
      statement: {
        prefix: 'This client',
        on: 'receives {{channel}} reminders',
        off: 'asked to stop {{channel}} reminders',
      },
      // Says WHEN and nothing else: the channel is already named, in bold, on the line
      // above. Kept as two keys rather than one shared string so a channel can say
      // something different later without unpicking the callers.
      description: {
        email: 'Before each of their upcoming bookings',
        sms: 'Before each of their upcoming bookings',
      },
      options: {
        on: 'Receives them',
        off: 'Asked to stop',
      },
      reason: {
        label: 'Why is this client receiving {{channel}} reminders again?',
        why: 'They had asked you to stop. Reversing a recorded request needs a written reason.',
        scope:
          'This goes onto the {{channel}} reminders record only — not the others — and it cannot be corrected or deleted later. Write what the client asked for and when.',
        hint: 'Do not enter health details, diagnoses, or personal circumstances. Describe the request, not the client. Anything you write here stays on this client’s record permanently.',
        counter: '{{count}} / {{max}}',
        required: 'Record why this client is receiving {{channel}} reminders again',
        tooLong: 'The reason cannot be longer than {{max}} characters',
        // Names no channel on purpose: the refusal identifies it only inside an English
        // sentence, and guessing which one it meant would attribute the amendment wrongly.
        conflict:
          'This client had asked to stop receiving reminders, so reversing that needs a written reason. Check that every channel you changed back on has one, then save again. Nothing has been recorded yet.',
      },
    },
    fields: {
      mobilePhone: 'Mobile phone',
      firstName: 'First name',
      lastName: 'Last name',
      additionalPhone: 'Landline phone',
      email: 'Email',
      facebook: 'Facebook',
      gender: 'Gender',
      occupation: 'Occupation',
      dateOfBirth: 'Date of birth',
      acquisitionSource: 'How did you hear about us',
      address: 'Address',
      branch: 'Registration branch',
      notes: 'Notes',
    },
    snackbars: {
      saved: 'Contact saved successfully!',
      saveFailed: 'Failed to save contact',
      notFound: 'Contact not found',
      mobileCheckFailed: 'Something went wrong while checking mobile number',
      contactLinked: 'Contact linked to the company',
      contactUnlinked: 'Contact removed from the company',
    },
    validation: {
      mobileInUse:
        'The mobile phone is already used by contacts {{names}}. You can use it again with a different first name, but BEWARE you will have two or more contacts with the same mobile phone.',
      mobileRequired: 'Mobile phone is required',
      mobileInvalid: 'Mobile phone is not valid',
      firstNameRequired: 'First name is required',
      genderInvalid: 'The selected value is not among the allowed values.',
      additionalPhoneInvalid: 'The landline number is not valid',
      emailInvalid: 'The email address is not valid',
      facebookInvalid: 'The profile URL is not valid',
    },
    communication: {
      employeeRequired: 'Employee is required',
      statusRequired: 'Status is required',
      dateRequired: 'Date is required',
      reminderRequired: 'Reminder date is required for Recall',
    },
    companiesSection: {
      linkCompany: 'Link company',
      columns: {
        legalName: 'Legal name',
        type: 'Type',
        roles: 'Roles',
      },
      unlink: {
        title: 'Unlink from company',
        content: 'Do you want to unlink the contact from the company {{companyName}}?',
        confirm: 'Unlink',
      },
    },
    communications: {
      list: {
        title: 'Communications ({{count}})',
        newButton: 'New communication',
        columns: {
          date: 'Date',
          employee: 'Employee',
          contact: 'Contact',
          status: 'Status',
          notes: 'Notes',
        },
        reminderTooltip: 'Reminder: {{date}}',
        noRows: 'No communications',
        loadFailed: 'Failed to load communications',
        deleted: 'Communication deleted successfully',
        deleteFailed: 'Failed to delete communication',
        deleteTitle: 'Delete communication',
        deleteContent: 'Are you sure you want to delete this communication?',
        deleteConfirm: 'Delete',
      },
      modal: {
        createTitle: 'New communication',
        editTitle: 'Edit communication',
        fields: {
          employee: 'Employee',
          date: 'Date',
          status: 'Status',
          recallDateTime: 'Reminder date & time',
          notes: 'Notes',
        },
        createSuccess: 'Communication created successfully',
        updateSuccess: 'Communication updated successfully',
        saveFailed: 'Failed to save communication',
        createButton: 'Create',
        saveButton: 'Save',
        cancelButton: 'Cancel',
      },
    },
  },
  leads: {
    listTitle: 'Leads',
    createOrder: 'Create order',
    columns: {
      lastName: 'Last name',
      firstName: 'First name',
      mobilePhone: 'Mobile',
      email: 'Email',
      leadManager: 'Lead manager',
      participants: 'Participants',
      lastOrder: 'Last order',
    },
    tooltips: {
      customer: 'Customer (has a completed order)',
      viewOrder: 'View order',
    },
  },
  employees: {
    listTitle: 'Employees',
    addEmployee: 'Add employee',
    erganiEmployeesButton: 'Ergani employees',
    availableSlots: 'Available slots: {{count}}',
    active: 'Active',
    inactive: 'Inactive',
    backToList: 'Employees list',
    createTitle: 'Add employee',
    columns: {
      lastName: 'Last name',
      firstName: 'First name',
      mobilePhone: 'Mobile phone',
      email: 'Email',
      specialties: 'Specialties',
      status: 'Status',
      isErganiEmployee: 'Ergani employee',
    },
    tabs: {
      basicInfo: 'Basic information',
      employmentInfo: 'Employment details',
      schedule: 'Schedule',
      communications: 'Communications',
    },
    steps: {
      basicInfo: 'Basic information',
      workInfo: 'Employment details',
    },
    fields: {
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      mobilePhone: 'Mobile phone',
      taxIdentificationNumber: 'Tax ID',
      taxOffice: 'Tax office',
      nationalInsuranceNumber: 'AMA',
      iban: 'IBAN',
      bank: 'Bank',
      socialSecurityNumber: 'AMKA',
      additionalMobilePhone: '2nd mobile phone',
      additionalPhone: 'Landline phone',
      facebook: 'Facebook',
      serviceGroup: 'Specialty',
      contractualWorkWeekHours: 'Working hours',
      grossWage: 'Gross wage',
      netWage: 'Net wage',
      contractStart: 'Contract start date',
      contractEnd: 'Contract end date',
      isErganiEmployee: 'Ergani employee',
    },
    placeholders: {
      fillIban: 'Fill in the IBAN',
    },
    tooltips: {
      mobileCheck: 'Check phone number usage in existing employees',
      contractEndAutoDeactivate: 'Auto-deactivate staff after contract end',
      contractEndDeactivates: 'After the contract end date the employee becomes inactive',
      edit: 'Edit',
    },
    actions: {
      previous: 'Previous',
      next: 'Next',
      check: 'Check',
      continue: 'Continue',
      newContact: 'New contact',
    },
    dialogs: {
      mobileCheck: {
        title: 'Mobile phone check',
        description: 'Check whether the mobile phone you want to enter is already used by one or more contacts',
      },
      contactExists: {
        title: 'Select contact',
        usedBy: 'The mobile phone <b>{{phone}}</b> is used by:',
        inEmployees: 'The following employees',
        inContacts: 'The following contacts',
        help: {
          title: 'What should I press?',
          continue: '<b>Continue</b> to pre-fill the data.',
          newContact:
            '<b>New contact</b> to create a contact with this mobile and a different name. Beware: you will have two or more contacts with the same mobile.',
          cancel: '<b>Cancel</b> to enter a new mobile phone.',
        },
      },
    },
    snackbars: {
      saved: 'Employee saved successfully!',
      saveFailed: 'Failed to save employee',
      notFound: 'Employee not found',
      ibanCheckFailed: 'Something went wrong while checking IBAN',
      mobileCheckFailed: 'Something went wrong while checking mobile number',
    },
    validation: {
      ibanInvalidFormat: 'IBAN must contain only Latin characters and digits',
      ibanInvalid: 'IBAN is not valid',
      dateInvalid: 'Please enter a valid date',
      dateRequired: 'Date is required',
      contractStartBeforeEnd: 'Contract start must precede the end date',
      contractEndAfterStart: 'Contract end must be after the start date',
      mobileRequired: 'Mobile phone is required',
      mobileInvalid: 'Mobile phone is not valid',
      firstNameRequired: 'First name is required',
      emailInvalid: 'The email address is not valid',
      ssnInvalid: 'AMKA is not valid',
      ninInvalid: 'AMA is not valid',
      tinInvalid: 'Tax ID is not valid',
      additionalPhoneInvalid: 'The landline number is not valid',
      phoneInUse: 'The number is already used',
      numberInvalid: 'Please enter a valid number',
      hoursMin: 'Minimum employment duration is 1 hour',
      hoursMax: 'Employment duration is not valid',
      hoursRequired: 'Employment duration is required',
      mobileInUse:
        'The mobile phone is already used by employee {{name}}. You can use it again with a different first name, but BEWARE you will have two or more employees with the same mobile.',
    },
    schedule: {
      title: 'Employee plan',
      sections: {
        current: 'Current plan',
        future: 'Scheduled plans',
        past: 'Plan history',
        overrideHistory: 'Emergency modifications history',
        activeOverrides: 'Emergency modifications',
        workHours: 'Working hours',
        breaks: 'Break',
        shift1: 'Schedule 1',
        shift2: 'Schedule 2',
      },
      empty: 'No active plan. Press "New plan" to create a plan.',
      fields: {
        title: 'Title:',
        titlePlaceholder: 'e.g. May 2025',
        startDate: 'Start date:',
        endDate: 'End date:',
        alternatingWeeks: 'Alternating schedules',
        selectMode: 'Select',
        days: 'Days',
      },
      modes: {
        sameHours: 'Same hours for every day',
        differentHours: 'Different hours for every day',
      },
      dayType: {
        working: 'Working day',
        nonWorking: 'Non-working day',
      },
      columns: {
        dayType: 'Day type',
        name: 'Title',
        planTitle: 'Plan title',
        overrideDate: 'Date',
        effectiveFrom: 'Start date',
        effectiveTo: 'End date',
      },
      currentItem: {
        startDate: 'Start date: <b>{{date}}</b>',
        endDate: 'End date: <b>{{date}}</b>',
      },
      overrideItem: {
        date: 'Date: <b>{{date}}</b>',
      },
      actions: {
        planOverride: 'Plan override',
        newPlan: 'New plan',
        update: 'Update',
        addShift: 'Add shift',
        addBreak: 'Add break',
        editPlan: 'Edit plan',
        today: 'Today',
        saveAsDayOff: 'Save as day off',
      },
      snackbars: {
        created: 'Plan saved successfully!',
        createdPlanPending: 'The plan was created, but saving working hours failed. Try again with Update.',
        updated: 'Plan updated successfully!',
        saveFailed: 'Failed to save plan',
        overlap: 'The plan overlaps with another plan',
        devBypassConflict: 'Dev: updated the existing overlapping plan (conflict bypass)',
        fetchFailed: 'Something went wrong.',
      },
      deleteDialog: {
        title: 'Delete plan',
        contentCurrent: 'Are you sure you want to delete the current plan?',
        contentScheduled: 'Are you sure you want to delete this scheduled plan?',
        contentPast: 'Are you sure you want to delete this plan from history?',
        contentOverride: 'Are you sure you want to delete this emergency schedule override?',
        cancel: 'Not yet',
        confirm: 'Yes, delete',
      },
      ergani: {
        sendButton: 'Send to ERGANI',
        sentChip: 'Sent to ERGANI',
        pendingChip: 'Pending submission',
        sentAtTooltip: 'Sent on {{date}}',
        snackbars: {
          sendSuccess: 'Weekly schedule sent to ERGANI successfully',
          sendFailed: 'Failed to send weekly schedule to ERGANI',
        },
      },
      override: {
        title: 'Plan override',
        dateLabel: 'Date to override:',
        dayOff: 'The selected date is non-working for the employee.',
        tooltips: {
          addShift: 'Add shift',
          deleteShift: 'Delete shift',
          addBreak: 'Add break',
          deleteBreak: 'Delete break',
        },
        snackbars: {
          searchFailed: 'Failed to search override',
          deleted: 'Override deleted',
          deleteFailed: 'Failed to delete override',
          saved: 'Override saved',
          saveFailed: 'Failed to save override',
        },
        ergani: {
          sendButton: 'Send to ERGANI',
          sentChip: 'Sent to ERGANI',
          pendingChip: 'Pending submission',
          snackbars: {
            sendSuccess: 'Successfully sent to ERGANI',
            sendFailed: 'Failed to send to ERGANI',
            alreadySent: 'Override already sent to ERGANI',
          },
        },
      },
      overrideHistory: {
        snackbars: {
          fetchFailed: 'Failed to load emergency modifications history',
        },
      },
      validation: {
        startRequired: "'From' time is required",
        endRequired: "'To' time is required",
        endAfterStart: "'To' time must be after 'from' time",
        nameRequired: 'Plan name is required',
        dateInvalid: 'Please enter a valid date',
        dateRequired: 'Date is required',
        planStartBeforeEnd: 'Plan start must precede the end date',
        planEndAfterStart: 'Plan end must follow the start date',
      },
    },
    plan: {
      backToEdit: 'Edit employee',
      notFound: 'Plan not found',
      legend: {
        work: 'Working hours',
        break: 'Breaks',
        today: 'Current day',
      },
    },
  },
  ergani: {
    employees: {
      title: 'Ergani employees',
      sendButton: 'Send to Ergani',
      sending: 'Sending...',
      selected_one: 'Selected',
      selected_other: 'Selected',
      columns: {
        scheduleStatus: 'Schedule in Ergani',
      },
      status: {
        sent: 'Has been sent',
        pending: 'Has not been sent',
      },
      snackbars: {
        fetchFailed: 'Failed to load employees',
        sendSuccess: 'Weekly schedule sent to ERGANI successfully',
        sendFailed: 'Failed to send to ERGANI',
        endpointUnavailable: 'The endpoint is not available yet. Please contact the backend team.',
        nothingToSend: 'No pending schedules to send',
        bulkSendSuccess_one: '{{count}} schedule sent to ERGANI successfully',
        bulkSendSuccess_other: '{{count}} schedules sent to ERGANI successfully',
        noScheduleForEmployee: '{{name}}: there is no active plan to send',
        sendFailedForEmployee: '{{name}}: failed to send the schedule to ERGANI',
      },
    },
  },
  services: {
    listTitle: 'Services',
    addService: 'Create service',
    reorderTitle: 'Change display order',
    available: 'Available',
    unavailable: 'Unavailable',
    active: 'Active',
    inactive: 'Inactive',
    minute: 'minute',
    minutes: 'minutes',
    cannotDisableLastActive: 'Cannot disable the only active service of this specialty',
    createTitle: 'Create service',
    backToList: 'Services list',
    columns: {
      name: 'Name',
      code: 'Code',
      netAmount: 'Amount excluding VAT',
      vatPercentage: 'VAT category',
      grossAmount: 'Total amount',
      duration: 'Duration',
      status: 'Status',
    },
    sections: {
      basicInfo: 'Basic information',
      amount: 'Amount',
      duration: 'Duration',
      publicBooking: 'Online booking',
    },
    fields: {
      name: 'Name',
      category: 'Category',
      status: 'Status',
      netAmount: 'Amount excluding VAT',
      grossAmount: 'Amount including VAT',
      vatPercentage: 'VAT category (%)',
      durationInMinutes: 'Service duration (minutes)',
      preparationDurationInMinutes: 'Preparation duration (minutes)',
      overlapAvailabilityDurationInMinutes: 'Overlap availability duration (minutes)',
      bufferDurationInMinutes: 'Extra service time (minutes)',
      offeredForPublicBooking: 'Available for online booking',
      comments: 'Notes',
    },
    placeholders: {
      durationServiceExample: 'e.g. 120',
      durationOtherExample: 'e.g. 10',
    },
    tooltips: {
      durationService: 'Time required by the procedure in minutes',
      preparation: 'Required preparation time before the procedure starts in minutes',
      overlap: 'Time of parallel customer service in minutes',
      buffer: 'Customer waiting time in minutes',
    },
    snackbars: {
      saved: 'Service saved successfully!',
      saveFailed: 'Failed to save service',
      notFound: 'Service not found',
      reorderSuccess: 'Order updated successfully',
    },
    validation: {
      nameRequired: 'Service name is required',
      vatInvalid: 'The selected value is not among the allowed values.',
      vatRequired: 'VAT percentage is required',
      durationPositive: 'Negative duration is not allowed',
      durationMin: 'Service duration must be at least 1 minute',
      durationRequired: 'Service duration is required',
      prepDurationMin: 'Preparation duration must be at least 1 minute',
      overlapMin: 'Overlap minutes must be at least 1',
      bufferMin: 'Buffer time must be at least 1 minute',
    },
    reorder: {
      title: 'Change services display order',
      description:
        'Adjust the display order of services on the online booking page. Changes are saved automatically and applied immediately.',
      empty: 'No services have been registered yet',
    },
  },
  orders: {
    listTitle: 'Orders',
    createOrder: 'Create order',
    backToList: 'Orders list',
    title: 'Order',
    statusLabel: 'Order status:',
    completeButton: 'Complete',
    columns: {
      orderNumber: 'Order #',
      createdAt: 'Created on',
      lead: 'Lead',
      company: 'Company',
      leadManager: 'Lead Manager',
      participants: 'Participants',
      totalAmount: 'Amount incl. VAT',
      status: 'Order status',
    },
    clone: {
      title: 'Clone order',
      content: 'Do you want to clone the order {{orderId}}?',
      success: 'Order {{orderId}} cloned successfully',
    },
    totals: {
      label: 'Total (incl. VAT)',
      error: 'Unable to load total',
    },
    create: {
      title: 'Create order',
      branch: 'Select branch',
      allBranches: 'All branches',
      searchAccordion: 'Search contact{{ companyPart }}',
      companyPart: '/company',
      contact: 'Contact',
      newContact: 'Create new contact',
      mobilePhone: 'Mobile phone',
      firstName: 'First name',
      lastName: 'Last name',
      companyOrder: 'Company order',
      contactCompany: 'Contact company',
      snackbars: {
        contactExists: 'Contact already exists',
        contactCreateFailed: 'Failed to create contact',
        saveFailed: 'Failed to save order',
      },
    },
    sections: {
      basicInfo: 'Basic information',
      items: 'Items',
      payments: 'Payments',
      otherInfo: 'Other information',
    },
    fields: {
      client: 'Customer',
      company: 'Company',
      effectiveFrom: 'Creation date',
      expiresOn: 'Expiry date',
      leadManager: 'Employee (Lead Manager)',
      participants: 'Participants',
      notes: 'Notes',
      paymentMethod: 'Payment method:',
      totalDiscountAmount: 'Total discount (€):',
      totalDiscountPercentage: 'Total discount (%):',
      totalAmount: 'Total amount:',
    },
    items: {
      service: 'Service',
      netAmount: 'Amount excl. VAT',
      vat: 'VAT',
      discountAmount: 'Discount €',
      discountPercentage: 'Discount %',
      total: 'Total',
    },
    payments: {
      emptyState: 'Add items and the payment plan will be created',
      title: 'Payment {{number}}',
      dueBy: 'Due by:',
      method: 'Payment method:',
      total: 'Total',
      edit: 'Edit payment',
      editTitle: 'Edit payment {{number}}',
      fields: {
        paymentMethod: 'Payment method',
        dueDate: 'Due date',
      },
      validation: {
        methodRequired: 'Payment method is required',
        dueDateRequired: 'Due date is required',
      },
      updateSuccess: 'Payment updated',
    },
    selectPaymentMethod: 'Select payment method',
    snackbars: {
      updated: 'Order updated',
      itemAdded: 'Service added',
      itemDeleted: 'Service removed',
      saveFailed: 'Failed to save order',
      genericFail: 'Something went wrong.',
      notFound: 'Order not found',
      invoiceCancelled: 'Invoice cancelled',
      invoiceSubmitted: 'Invoice submitted to AADE',
    },
    delete: {
      title: 'Delete order',
      content: 'Do you want to delete the order #{{orderId}}?',
    },
    completeStatus: {
      title: 'Complete order',
      content: 'After completing the order, you will only be able to manage invoices. Are you sure you want to continue?',
      confirmButton: 'Yes, complete',
      cancelButton: 'Not yet',
    },
    invoicePrint: {
      invoiceTitle: 'Service Invoice',
      receiptTitle: 'Service Receipt',
      issued: 'Issued',
      statuses: {
        DRAFT: 'Draft',
        ISSUED: 'Issued',
        PUBLISHED: 'Submitted',
        CANCELLED: 'Cancelled',
      },
      missingCompany: 'No company linked',
      noSeries: 'No series',
      vatNumber: 'VAT No.',
      invoiceDetails: 'Invoice Details',
      receiptDetails: 'Receipt Details',
      customerDetails: 'Customer Details',
      date: 'Date',
      dueDate: 'Due date',
      paymentMethod: 'Payment Method',
      finalTotal: 'Final Total',
      columns: {
        service: 'Service',
        netAmount: 'Net Amount',
        vat: 'VAT',
        discount: 'Discount',
        total: 'Total',
      },
      myData: {
        title: 'myDATA connection',
        mark: 'MARK',
        uid: 'Invoice UID',
      },
    },
    validation: {
      totalDiscountRequired: 'Total discount is required',
      totalAmountRequired: 'Total amount is required',
      currencyInvalid: 'The selected value is not among the allowed values.',
      serviceRequired: 'Service is required',
      netAmountRequired: 'Amount excluding VAT is required',
      vatPercentageRequired: 'VAT category is required',
      itemTotalRequired: 'Total is required',
      statusRequired: 'Order status is required',
      effectiveFromRequired: 'Creation date is required',
      clientRequired: 'Customer is required',
      atLeastOneItem: 'The order must include at least one service',
      mobileRequired: 'Mobile phone is required',
      mobileInvalid: 'Mobile phone is not valid',
      grossTotalMax: 'The total must not exceed {{max}}€',
    },
    drawer: {
      title: 'Invoices for {{invoiceName}}',
      subtitle: {
        active: 'Active invoice',
        previous: 'Previous invoices',
      },
      fields: {
        status: 'Status',
        sequence: {
          label: 'Numbering sequence',
          emptyState: 'Select numbering sequence',
        },
        dueDate: 'Date',
        issuedDate: 'Issued date',
        paymentMethod: 'Payment method',
      },
      draftStatus: 'Draft',
      viewDraft: 'View draft',
      previewTitle: 'Draft preview',
      printPreview: 'Print',
      noInvoiceSeries:
        'You have not created any numbering series yet. You can create one by clicking the purple settings button on the right.',
      invoiceLoadFailed: 'Invoices could not be loaded. Invoice actions are unavailable until you try again.',
      aadeNotConnected: 'You are not connected to AADE. Connect from invoicing settings before submitting invoices.',
      generateInvoice: 'Issue invoice',
      viewInvoice: 'View',
      manageInvoices: 'Manage invoices',
      invoicesDisabledNotCompleted: 'Invoices are only available for completed orders',
      cancelInvoice: 'Cancel',
      submitInvoice: 'Submit to AADE',
      confirmations: {
        issueTitle: 'Issue invoice',
        issueContent:
          'Are you sure you want to issue this invoice? No changes are allowed after issuance. The payment method & due date will be printed on the invoice.',
        issueConfirm: 'Issue invoice',
        issueCancel: 'Do not issue',
        submitTitle: 'Submit invoice to AADE',
        submitContent: 'Are you sure you want to submit this invoice to AADE?',
        submitConfirm: 'Submit the invoice',
        submitCancel: 'Do not submit',
        cancelTitle: 'Cancel invoice',
        cancelContent: 'Are you sure you want to cancel this invoice?',
        cancelConfirm: 'Cancel invoice',
        cancelCancel: 'Do not cancel',
      },
      cancelledInvoice: {
        issuedDate: 'Issued',
        cancelledDate: 'Cancelled',
        aadeCancellationMark: 'AADE cancellation MARK',
      },
      publishedInvoice: {
        notice: 'Submitted to AADE (myDATA)',
      },
    },
  },
  bookings: {
    calendarTitle: 'Calendar',
    listTitle: 'Bookings',
    backToCalendar: 'Calendar',
    columns: {
      contact: 'Customer',
      dateTime: 'Date/Time',
      service: 'Service',
      amount: 'Amount',
      employee: 'Employee',
      status: 'Booking status',
    },
    delete: {
      title: 'Delete booking',
      content: 'Do you want to delete the booking {{bookingId}}?',
    },
    toolbar: {
      list: 'Bookings list',
      newBooking: 'New booking',
      today: 'Today',
      filters: 'Filters',
      filtersLabel: 'Filters:',
      filtersTitle: 'Booking filters',
      apply: 'Apply',
      filterChip: {
        contact: 'Customer: {{name}}',
        service: 'Service: {{name}}',
        status: 'Status: {{name}}',
      },
    },
    drawer: {
      service: 'Service',
      contact: 'Customer',
      status: 'Booking status',
    },
    validation: {
      dateRequired: 'Date is required',
      timeRequired: 'Time is required',
      employeeRequired: 'Employee selection is required',
      firstNameRequired: 'First name is required',
      mobileRequired: 'Mobile phone is required',
      mobileInvalid: 'Mobile phone is not valid',
      emailRequired: 'Customer email is required',
      emailInvalid: 'The email address is not valid',
      serviceRequired: 'Service selection is required',
    },
    snackbars: {
      created: 'Booking created',
      updated: 'Booking updated',
      deleted: 'Booking deleted',
      saved: 'Booking saved.',
      cancelled: 'Booking cancelled.',
      saveFailed: 'Something went wrong.',
      notFound: 'Booking not found',
      mobileCheckFailed: 'Something went wrong while checking the mobile phone',
      contactCreateFailed: 'Failed to create contact',
      pickContactWarning: 'Select an existing contact or create a new one.',
    },
    form: {
      backToList: 'Bookings list',
      titleEdit: 'Edit booking',
      titleNew: 'New booking',
      statusPlaceholder: 'Booking status',
      statusLabel: 'Booking status',
      completedAlert: 'The booking is completed. To edit it, change the status of the linked',
      completedAlertLink: 'order',
      date: 'Date',
      time: 'Time',
      employee: 'Employee',
      service: 'Service',
      comments: 'Notes',
      searchExistingContact: 'Search existing contact',
      newContactSection: 'Create new contact',
      mobilePhone: 'Mobile phone',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      clientEmail: 'Customer email',
      notifyClient: 'Notify customer',
      notifyClientTooltip:
        "If you enable customer notifications, when the booking transitions to 'Active' status or is cancelled, an email with the booking details will be sent to the customer.",
      save: 'Save',
      create: 'Create',
      cancelButton: 'Cancel',
      cancelBooking: 'Cancel booking',
      cancelDialogTitle: 'Cancel booking',
      cancelDialogContent: 'Are you sure you want to cancel this booking?',
      clientReminders: {
        title: "This customer's reminder record",
        loading: 'Loading the reminder record…',
        unavailable: "This customer's reminder record could not be loaded.",
        smsOn: 'SMS reminders: on',
        smsOff: 'SMS reminders: off — the customer asked for these to stop',
        emailOn: 'Email reminders: on',
        emailOff: 'Email reminders: off — the customer asked for these to stop',
        confirmationsNote: 'This record does not affect booking confirmation or cancellation emails.',
        permanenceNote: 'A change to this record is permanently recorded against the user who makes it.',
        changeLink: "Open the customer's page to change this",
      },
    },
  },
  statistics: {
    title: 'Statistics',
    totalRevenue: 'Total revenue',
    monthlyRevenue: 'Monthly revenue',
    compareLastYear: 'vs. same period last year',
    noData: 'No data available',
    revenueByMonth: 'Revenue per month',
    revenueByService: 'Revenue per service',
    revenueByServiceCategory: 'Revenue per service category',
    revenueByEmployee: 'Revenue per employee',
    revenueByEmployeeService: 'Revenue per employee per service',
    completedOnlyTooltip: 'Only completed orders',
    dateRange: {
      start: 'From',
      end: 'To',
    },
  },
  dashboard: {
    listTitle: 'Overview',
    period: {
      label: 'Time period',
      last7: 'Last 7 days',
      last30: 'Last 30 days',
      last365: 'Last 365 days',
    },
    activeClients: {
      title: 'Active customers',
      tooltip: 'Your customers who have completed orders',
    },
    noShow: {
      title: 'No-show ratio',
      tooltip:
        'The %NSA ratio (No Show Appointments) is a metric that measures the percentage of scheduled appointments that did not take place because the customer did not show up, without having cancelled the appointment.',
    },
    availableEmployees: {
      title: 'Available today',
      empty: 'No available employees.',
    },
    nextAppointments: {
      title: "Today's upcoming appointments",
      empty: 'No appointments today.',
      defaultService: 'Service',
      with: 'with {{name}}',
    },
    pendingAppointments: {
      title: 'Unconfirmed appointments',
      empty: 'No unconfirmed appointments',
      confirmTooltip: 'Confirm appointment',
      cancelTooltip: 'Cancel appointment',
      openTooltip: 'Open appointment',
      confirmedSnackbar: 'Appointment confirmed.',
      cancelledSnackbar: 'Appointment cancelled.',
      confirmFailed: 'Failed to confirm appointment',
      cancelFailed: 'Failed to cancel appointment',
    },
    topClients: {
      title: 'Top 10 customers',
      empty: 'No data available',
      loadFailed: 'Failed to load customers',
      sortVisits: 'Visits',
      sortPayments: 'Payments',
    },
    topServices: {
      title: 'Top 10 services',
      empty: 'No data available',
      loadFailed: 'Failed to load services',
      sortCount: 'Quantity',
      sortCost: 'Revenue',
    },
    notices: {
      loadFailed: {
        title: 'Some invoicing setup checks could not be loaded',
        description: 'Setup notices may be incomplete. Try loading them again.',
        cta: 'Try again',
      },
      missingAadeCredentials: {
        title: 'AADE connection is pending',
        description: 'Connect via myAADE from invoicing settings to enable tax authority submission.',
        cta: 'Go to invoicing settings',
      },
      noTenantCompanies: {
        title: 'No company registered',
        description: 'Registering a company is required to issue invoices in your Orders.',
        cta: 'Go to Companies',
      },
      unlinkedBranches: {
        title: 'Some of your branches are not linked to your companies',
        description: 'Linking is required to issue invoices in your Orders.',
        cta: 'Go to Branches',
      },
    },
  },
  apiErrors: {
    erganiInvalidCredentials: 'Invalid ERGANI username or password',
    erganiUnavailable: 'ERGANI is unavailable right now. Please try again later.',
    erganiBranchAlreadyAssociated: 'This store is already connected to another ERGANI branch.',
    activeBranchLimitReached: 'You have reached the maximum number of active branches ({{branchLimit}}). Contact us for an upgrade.',
    activeEmployeeLimitReachedForTier:
      "You have reached the active employee limit for the '{{tierCode}}' tier ({{employeeLimit}}). Upgrade your plan.",
    aadeCredentialsInvalid: 'Invalid myAADE credentials. Please check the username and password.',
    orderStatusNotEligible: "This order's status no longer allows invoicing.",
    orderBranchNoCompany: "This order's branch isn't linked to a company.",
  },
  validation: {
    money: {
      amountInvalid: 'Please enter a valid number',
      amountRequired: 'The amount is required',
      amountNonNegative: 'Negative values are not allowed',
      currencyRequired: 'The currency is required',
    },
    logo: {
      fileRequired: 'Please choose a file',
      fileSizeMax: 'The file size must not exceed {{max}}MB',
      fileTypeImage: 'The file must be PNG or JPEG',
      fileExtensionInvalid: 'Invalid file extension',
      extensionInvalidWithFile: 'Invalid file extension: {{ext}}. Allowed: .png, .jpg, .jpeg',
      typeInvalid: 'Invalid file type',
      sizeMaxWithCurrent: 'The file size must not exceed 5MB (current: {{size}}MB)',
      imageTooSmall: 'The image is too small: {{width}}×{{height}}px (minimum: {{min}}px on the shortest side)',
      imageTooLarge: 'The image is too large: {{width}}×{{height}}px (maximum: {{max}}px on the longest side)',
      invalidImageFile: 'Invalid image file',
      readError: 'Error while reading the image',
      qualityExcellent: 'Excellent quality',
      qualityGood: 'Good quality',
      qualityAcceptable: 'Acceptable quality (higher resolution recommended)',
      uploaded: 'Logo uploaded successfully',
      uploadFailed: 'Upload failed. Please try again.',
    },
  },
  filters: {
    selected_one: '{{count}} selected',
    selected_other: '{{count}} selected',
    dateRangePlaceholder: 'From - To',
    lastOrder: {
      placeholder: 'From - To/Status',
      date: 'Date',
      status: 'Status',
      all: 'All',
    },
  },
  settings: {
    listTitle: 'Settings',
    tabs: {
      publicBooking: 'Online booking',
      serviceGroups: 'Specialties',
      acquisitionSources: 'Acquisition sources',
      orderStatuses: 'Order statuses',
      ergani: 'ERGANI',
      serviceCategories: 'Service categories',
      branches: 'Branches',
      companies: 'My companies',
      invoicing: 'Invoicing',
      calendar: 'Calendar',
    },
    item: {
      available: 'Available',
      unavailable: 'Unavailable',
    },
    tenants: {
      title: 'Tenants',
      addButton: 'Add tenant',
      empty: 'No tenants found',
      modalTitleAdd: 'Add tenant',
      modalTitleEdit: 'Edit tenant',
      featurePlaceholder: 'Choose features',
      fields: {
        name: 'Name',
        alias: 'Alias',
        tier: 'Tier',
        features: 'Features',
        firstName: 'Tenant Admin first name',
        lastName: 'Last name',
        email: 'Email',
        platformAdminEmail: 'Platform Admin Email',
      },
      validation: {
        nameRequired: 'Name is required',
        aliasRequired: 'Alias is required',
        tierRequired: 'Tier is required',
        firstNameRequired: 'First name is required',
        lastNameRequired: 'Last name is required',
        emailInvalid: 'Invalid email',
        emailRequired: 'Email is required',
      },
      snackbars: {
        created: 'Tenant created successfully!',
        createFailed: 'Failed to create tenant',
        updated: 'Tenant updated successfully!',
        updateFailed: 'Failed to update tenant',
        copied: 'Copied!',
      },
      buttons: {
        cancel: 'Cancel',
        save: 'Save',
      },
      onboardResult: {
        title: 'Tenant created',
        warning: 'Passwords will not appear again after closing this dialog. Note them down before continuing.',
        tenantPasswordLabel: 'Tenant admin password',
        platformPasswordLabel: 'Platform admin password',
        clickHere: 'Click Here',
        show: 'Show',
        hide: 'Hide',
        copy: 'Copy',
        close: 'Close',
      },
    },
    publicBooking: {
      title: 'Online bookings',
      branding: {
        title: 'Company branding',
      },
      nameForm: {
        label: 'Company name',
        helperText: 'The name shown to customers during online bookings',
        placeholder: 'Enter the name',
        charactersHelper: '{{count}}/{{max}} characters:',
        save: 'Save',
        updated: 'Name updated successfully',
        saveError: 'An error occurred while saving',
      },
      logoUpload: {
        title: 'Upload new logo',
        formats: 'Accepted formats: PNG, JPEG • Maximum size: 5MB • Dimensions: 100-3000px',
        chooseFile: 'Choose file',
        clear: 'Clear',
        publish: 'Publish',
      },
      logoPreview: {
        defaultCompany: 'Company',
        currentTitle: 'Current logo',
        previewTitle: 'Preview',
        previewBadge: 'Preview',
        previewLogoAlt: 'Logo preview',
        companyLogoAlt: '{{name}} logo',
        howItWillAppear: 'This is how your logo will appear on the bookings page',
        emptyPreview: 'No file selected',
        emptyCurrent: 'No logo uploaded',
        urlNote: 'Note: URLs expire after 10 minutes and are refreshed automatically',
      },
      bookingSummary: {
        previewTitle: 'Booking page preview',
        previewBadge: 'Preview',
        howItWillAppear: 'This is how your logo will appear on the bookings page',
        servicesTitle: 'Selected services',
        durationOneHour: '1 hour',
        totalCost: 'Total cost',
        sampleService: 'Haircut and styling',
      },
      wizardSteps: {
        title: 'Booking steps',
        description: 'Configure which steps appear on the online bookings page.',
        showEmployeeLabel: 'Show employee selection',
        showEmployeeHelper: 'When enabled, customers can select a specific employee during booking.',
        emailRequiredLabel: 'Require customer email',
        emailRequiredHelper:
          'When disabled, customers can book without an email. Bookings without email will not receive confirmation emails and will remain pending.',
        loadFailed: 'Failed to load settings',
        savedSuccess: 'Settings saved successfully',
        saveFailed: 'Failed to save settings',
      },
      ownerNotifications: {
        title: 'Owner notifications',
        description: 'Get an email when a customer books from the online bookings page. Does not apply to back-office bookings.',
        enableLabel: 'Send new-appointment notifications',
        enableHelper: 'Get an email when a customer books from online bookings. Does not apply to back-office bookings.',
        onlyConfirmedLabel: 'Only for confirmed bookings',
        onlyConfirmedHelper:
          'When on, you are emailed only after the customer confirms the booking. Turn it off to also be notified for pending (unconfirmed) bookings.',
        recipientEmailLabel: 'Recipient email',
        recipientEmailPlaceholder: 'Enter email',
        recipientEmailHelper: 'The address notifications will be sent to.',
        emailRequired: 'Email is required when a notification is enabled',
        emailInvalid: 'The email address is not valid',
        save: 'Save',
        savedSuccess: 'Settings saved successfully',
        saveFailed: 'Failed to save settings',
        loadFailed: 'Failed to load settings',
      },
    },
    calendarDisplay: {
      title: 'Calendar',
      panelTitle: 'Calendar display',
      description: 'Controls how the bookings calendar is shown. It does not change availability, bookings, or online booking.',
      startTime: 'From',
      startTimeHelper: 'First hour shown on the calendar',
      endTime: 'To',
      endTimeHelper: 'Last hour shown on the calendar',
      slotMinutes: 'Interval',
      slotMinutesOption: '{{minutes}} minutes',
      widenNote: 'If a booking falls outside this range, the view widens automatically for that day so the booking stays visible.',
      save: 'Save',
      savedSuccess: 'Settings saved successfully',
      saveFailed: 'Failed to save settings',
      loadFailed: 'Failed to load settings',
      validation: {
        startRequired: 'Start time is required',
        endRequired: 'End time is required',
        endAfterStart: 'End time must be after start time',
        slotRequired: 'Interval is required',
        slotInvalid: 'Choose 10, 15, 30 or 60 minutes',
      },
    },
    ergani: {
      reconnectTitle: 'Reconnect to ERGANI',
      initialTitle: 'Business connection details',
      businessDetailsTitle: 'Business details',
      branchesTitle: 'Branches',
      successChip: 'Successfully connected to ERGANI',
      disconnectButton: 'Disconnect',
      disconnectDialog: {
        title: 'Disconnect',
        content: 'Are you sure you want to disconnect the ERGANI account?',
        confirm: 'Disconnect',
      },
      reconnectButton: 'Connect with new credentials',
      saveButton: 'Save',
      cancelButton: 'Cancel',
      connectButton: 'Connect',
      fields: {
        username: 'Username',
        password: 'Password',
        companyName: 'Company name',
        taxId: 'Tax ID',
        erganiBranch: 'Branch',
        connectedStore: 'Connected to store',
        selectStore: 'Select',
      },
      snackbars: {
        connected: 'Connection to ERGANI completed successfully!',
        connectFailed: 'Connection to ERGANI failed',
        settingsSaved: 'Settings saved successfully!',
        settingsSaveFailed: 'Failed to save settings',
        mappingSaved: 'Branch connection saved',
        mappingRemoved: 'Branch connection removed',
        mappingSaveFailed: 'Failed to save the branch connection',
        loadFailed: 'Failed to load ERGANI details',
      },
      validation: {
        usernameRequired: 'Username is required',
        passwordRequired: 'Password is required',
        storeIdRequired: 'Number is required',
      },
    },
    serviceCategories: {
      title: 'Service categories',
      addButton: 'Add new category',
      reorderButton: 'Change display order',
      empty: 'No service categories found',
      tabHeading: 'Services in the {{name}} category',
      tabEmpty: 'There are no services in this category',
      inactiveChip: 'Inactive',
      editAction: 'Edit',
      modalTitleEdit: 'Edit category',
      modalTitleAdd: 'Add category',
      fields: {
        name: 'Category name',
        services: 'Services',
        servicePlaceholder: 'Pick a service',
      },
      validation: {
        nameRequired: 'Category name is required',
        nameDuplicate: 'A category with this name already exists',
      },
      snackbars: {
        saved: 'Category saved successfully!',
        updated: 'Category updated successfully!',
        deleted: 'Category deleted successfully!',
        saveFailed: 'Failed to save category',
        updateFailed: 'Failed to update category',
        deleteFailed: 'Failed to delete category',
        reorderSuccess: 'Order updated successfully',
      },
      deleteDialog: {
        title: 'Confirm deletion',
        content: 'Are you sure you want to delete the category {{name}}?',
        confirm: 'Delete',
      },
      reorder: {
        title: 'Change category display order',
        description: 'Adjust the display order of service categories. Changes are saved automatically and applied immediately.',
        empty: 'No categories have been registered yet',
        close: 'Close',
      },
      services_one: '{{count}} service',
      services_other: '{{count}} services',
      buttons: {
        cancel: 'Cancel',
        save: 'Save',
        create: 'Create',
      },
    },
    orderStatuses: {
      title: 'Order statuses',
      defaultLabel: 'Default order status',
      orderTitle: 'Order status sequence',
      active: 'Active',
      inactive: 'Inactive',
      snackbars: {
        updated: 'Status updated successfully',
        updateFailed: 'Something went wrong.',
      },
    },
    acquisitionSources: {
      title: 'Where you found us',
      addButton: 'Add source',
      empty: 'No sources found',
      modalTitleEdit: 'Edit source',
      modalTitleAdd: 'Add source',
      fields: {
        name: 'Source',
      },
      validation: {
        nameRequired: 'The source is required',
      },
      snackbars: {
        saved: 'Source saved successfully!',
        updated: 'Source updated successfully!',
        deleted: 'Source deleted successfully!',
        saveFailed: 'Failed to save source',
        updateFailed: 'Failed to update source',
        deleteFailed: 'Failed to delete source',
        enableFailed: 'Failed to enable source',
        disableFailed: 'Failed to disable source',
      },
      deleteDialog: {
        title: 'Confirm deletion',
        content: 'Are you sure you want to delete this source {{name}}?',
        confirm: 'Delete',
      },
      buttons: {
        cancel: 'Cancel',
        save: 'Save',
        create: 'Create',
      },
    },
    serviceGroups: {
      title: 'Specialties',
      addButton: 'Add specialty',
      empty: 'No specialties found',
      modalTitleEdit: 'Edit specialty',
      modalTitleAdd: 'Add specialty',
      fields: {
        name: 'Specialty name',
        services: 'Services',
        servicePlaceholder: 'Pick a service',
      },
      validation: {
        nameRequired: 'Name is required',
        servicesRequired: 'You must select at least 1 service',
      },
      snackbars: {
        saved: 'Specialty saved successfully!',
        updated: 'Specialty updated successfully!',
        deleted: 'Specialty deleted successfully!',
        saveFailed: 'Failed to save specialty',
        updateFailed: 'Failed to update specialty',
        deleteFailed: 'Failed to delete specialty',
        enableFailed: 'Failed to enable specialty',
        disableFailed: 'Failed to disable specialty',
      },
      deleteDialog: {
        title: 'Confirm deletion',
        content: 'Are you sure you want to delete the specialty {{name}}?',
        confirm: 'Delete',
      },
      buttons: {
        cancel: 'Cancel',
        save: 'Save',
        create: 'Create',
      },
    },
    branches: {
      title: 'Branches',
      addButton: 'Add branch',
      addButtonDisabledTooltip: 'You have reached the maximum number of branches. Contact us for an upgrade.',
      empty: 'No branches found',
      modalTitleEdit: 'Edit branch',
      modalTitleAdd: 'Add branch',
      linkedCompany: 'Linked company',
      noCompanyWarning: 'This branch has no linked company and cannot issue invoices.',
      addCompany: 'Link company',
      backToList: 'Branch list',
      detailTitle: 'Basic information',
      fields: {
        name: 'Branch name',
        address: 'Address',
        linkToCompany: 'My linked company',
        aadeBranchCode: 'AADE Branch Code',
        aadeBranchCodeTooltip: 'Number 0 is for the headquarters. You can find installation numbers in your taxis account',
      },
      validation: {
        nameRequired: 'Branch name is required',
        addressRequired: 'Address is required',
        aadeBranchCodeInvalid: 'Branch code must be a non-negative integer',
      },
      snackbars: {
        saved: 'Branch saved successfully!',
        updated: 'Branch updated successfully!',
        deleted: 'Branch deleted successfully!',
        saveFailed: 'Failed to save branch',
        updateFailed: 'Failed to update branch',
        deleteFailed: 'Failed to delete branch',
        enableFailed: 'Failed to enable branch',
        disableFailed: 'Failed to disable branch',
      },
      deleteDialog: {
        title: 'Confirm deletion',
        content: 'Are you sure you want to delete the branch "{{name}}"?',
        confirm: 'Delete',
      },
      buttons: {
        cancel: 'Cancel',
        save: 'Save',
        create: 'Create',
      },
    },
    invoicing: {
      title: 'Invoicing',
      sectionTitle: 'Invoicing series',
      addButton: 'Add series',
      empty: 'You have no invoicing series.\nClick "Add series" to create one.',
      modalTitleAdd: 'Add series',
      modalTitleEdit: 'Edit series',
      fields: {
        name: 'Series name',
        nextInvoiceNumber: 'Next invoice number',
      },
      helperTexts: {
        editWarning: 'All records using this series will be affected by the changes.',
        nextInvoiceNumber:
          'Leave empty to start from 1. If you are migrating invoices from another system, enter the next number to issue here.',
      },
      validation: {
        nameRequired: 'Series name is required',
        nextInvoiceNumberInvalid: 'Next invoice number must be a whole number of at least 1',
      },
      item: {
        notUsed: 'Not used yet',
        usedInRecords_one: 'Used in {{count}} record',
        usedInRecords_other: 'Used in {{count}} records',
        defaultChip: 'Default',
        active: 'Active',
      },
      tooltips: {
        defaultChip: 'This is the series that appears as default every time an invoice document is created.',
        cannotEdit: 'You cannot change the series name because one or more documents with this series have been sent to myDATA.',
        cannotDeactivateDefault: 'To deactivate this series, first select another one as default.',
      },
      snackbars: {
        created: 'Series created successfully!',
        updated: 'Series updated successfully!',
        defaultSet: 'Series set as default!',
        deactivated: 'Series deactivated successfully!',
        activated: 'Series activated successfully!',
        createFailed: 'Failed to create series',
        updateFailed: 'Failed to update series',
        defaultFailed: 'Failed to change default series',
        toggleFailed: 'Failed to change series status',
      },
      buttons: {
        cancel: 'Cancel',
        save: 'Save',
        create: 'Create',
      },
      aade: {
        sectionTitle: 'Connect to myAADE',
        loadFailed: 'We could not load the myAADE connection settings. Try again.',
        connectedTitle: 'myAADE Details',
        successChip: 'Connected to myAADE',
        fields: {
          userId: 'Username',
          subscriptionKey: 'Password',
        },
        connectButton: 'Connect',
        disconnectButton: 'Disconnect',
        cancelButton: 'Cancel',
        validation: {
          userIdRequired: 'Username is required',
          subscriptionKeyRequired: 'Password is required',
        },
        snackbars: {
          connected: 'Successfully connected to myAADE!',
          connectFailed: 'Failed to connect to myAADE',
          disconnected: 'Successfully disconnected from myAADE!',
        },
        disconnectDialog: {
          title: 'Disconnect myAADE',
          content: 'Are you sure you want to disconnect from myAADE? You will not be able to submit documents to AADE.',
          confirm: 'Disconnect',
        },
      },
    },
  },
  companies: {
    listTitle: 'Companies',
    addCompany: 'Add company',
    backToList: 'Companies list',
    empty: 'No companies found',
    columns: {
      taxId: 'Tax ID',
      legalName: 'Legal name',
      registeredAddress: 'Address',
      tradeName: 'Activity',
      companyType: 'Company type',
      country: 'Country',
    },
    fields: {
      taxId: 'Tax ID',
      legalName: 'Legal name',
      registeredAddressVies: 'VIES address',
      address: 'Address',
      country: 'Country',
      activity: 'Activity',
      companyType: 'Company type',
      tradeName: 'Trade name',
      location: 'Location',
    },
    sections: {
      basicInfo: 'Basic information',
      linkedContacts: 'Linked contacts',
    },
    contactColumns: {
      lastName: 'Last name',
      firstName: 'First name',
      role: 'Role',
    },
    actions: {
      linkContact: 'Link contact',
      updateViaVies: 'Update via VIES',
      lastUpdated: 'Last updated: {{date}}',
      viaVies: 'via VIES',
    },
    search: {
      mobilePlaceholder: 'Name, Tax ID, Country',
    },
    tabs: {
      details: 'Details',
      contacts: 'Contacts',
    },
    addModal: {
      searchTitle: 'Search in VIES/TaxisNet',
      detailsTitle: 'Company details from VIES/TaxisNet',
      manualTitle: 'Add company',
      manualEntry: 'Manual entry',
      newSearch: 'New search',
    },
    unlinkContact: {
      title: 'Remove contact from company',
      content: 'Do you want to remove the contact {{contactName}} from the company {{companyName}}?',
      confirm: 'Remove',
    },
    snackbars: {
      notFound: 'Company not found',
      updated: 'Company updated',
      saved: 'Company saved successfully!',
      contactLinked: 'Contact linked to the company',
      contactUnlinked: 'Contact removed from the company',
      taxIdAlreadyExists: 'A company with this Tax ID is already registered',
      viesNotActive: 'This Tax ID is not active in VIES',
      viesCredentialsInvalid: 'The login credentials are not correct',
      viesUnavailable: 'VIES service is not available',
    },
    validation: {
      taxIdRequired: 'Tax ID is required',
      countryRequired: 'Country is required',
      legalNameRequired: 'Legal name is required',
      activityRequired: 'Activity is required',
      addressRequired: 'Address is required',
      companyTypeRequired: 'Company type is required',
    },
  },
};

export default en;
